(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-hover-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hover-video-wrapper]').forEach(function (wrapper) {
      var video = wrapper.querySelector('video');
      var gallery = wrapper.closest('media-gallery');

      if (!gallery || !video) return;

      gallery.addEventListener('mouseenter', function () {
        wrapper.classList.add('is-active');
        video.play().catch(function () {});
      });

      gallery.addEventListener('mouseleave', function () {
        wrapper.classList.remove('is-active');
        video.pause();
        video.currentTime = 0;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-video-hover"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-hover-video').forEach(function (wrapper) {
      const video = wrapper.querySelector('video');
      const container = wrapper.closest('.product-media-gallery') || wrapper.parentElement;

      container.addEventListener('mouseenter', function () {
        video.play().catch(function () {});
      });

      container.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
